export const enterpriseBenefits = [
  [
    "Customer Success",
    "Recurso de Segurança (Rate Limit, IP White list)",
    "SSO (Single Sign On)",
    "Integrações via Make/Zapier com CRM/automação",
    "Onboarding Dedicado",
  ],
  [
    "Usuários ilimitados",
    "API ilimitada com suporte técnico",
    "Créditos Rollover (não expiram enquanto possuir contrato ativo)",
    "Suporte premium, especialistas em vendas e engenheiros de dados para trabalhos customizados",
  ],
];
